import React from 'react';
import type { JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';

import type { ToggleButtonProps } from './ToggleButton';

type ChangeEvent = React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>;
type ToggleButtonGroupProps<VALUE> = {
	ariaLabel: string;
	children:
		| React.ReactElement<ToggleButtonProps<VALUE>>
		| Array<React.ReactElement<ToggleButtonProps<VALUE>> | Array<React.ReactElement<ToggleButtonProps<VALUE>>>>;
	onChange: (e: ChangeEvent, value: VALUE) => void;
	value: VALUE;
} & Omit<React.ComponentPropsWithRef<typeof Box>, 'onChange'>;

export function ToggleButtonGroup<VALUE>({
	ariaLabel,
	children,
	onChange,
	value,
	...rest
}: ToggleButtonGroupProps<VALUE>): JSX.Element {
	return (
		<Box role="group" aria-label={ariaLabel} {...rest}>
			{/* eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion, @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument */}
			{React.Children.map(children as any, (child: React.ReactElement<ToggleButtonProps<VALUE>>) => {
				if (!React.isValidElement(child)) {
					return null;
				}

				const ToggleButton = child;

				return React.cloneElement(ToggleButton, {
					onChange,
					selected: ToggleButton.props.value === value,
					value: ToggleButton.props.value,
				});
			})}
		</Box>
	);
}
